// components/topology/nodes/VmNode.tsx
import React from 'react';
import { NodeProps, Position } from 'reactflow';
import { VmNodeData } from '../../../interfaces/Rmm';
import { badgeTone } from '../nodeUtils';
import BaseAssetNode from './BaseNode';

export function VmNode({ data, selected }: NodeProps<VmNodeData>) {
  const memGb = Math.round((data.vm.memoryMB ?? 0) / 1024);
  const invState = data.vm.state ?? 'Unknown';

  const label = data.rmm?.present ? data.rmm.status : invState;
  const tone = data.rmm?.present
    ? badgeTone(data.rmm.status)
    : badgeTone('unknown');

  return (
    <BaseAssetNode
      width={275}
      selected={selected}
      rmm={data.rmm}
      title={<>📦 {data.vm.name}</>}
      subtitle={`Host: ${data.hostName}`}
      badges={
        <>
          <span className={`text-[11px] px-2 py-1 rounded-full ${tone}`}>
            {label}
          </span>

          <span className="text-[11px] px-2 py-1 rounded-full bg-indigo-50 text-indigo-800">
            {data.vm.cpuCount} vCPU
          </span>

          <span className="text-[11px] px-2 py-1 rounded-full bg-emerald-50 text-emerald-800">
            {memGb} GB
          </span>
        </>
      }
      handle={{ type: 'target', position: Position.Top }}
    />
  );
}

export default VmNode;
